import IcAppConfig from 'assets/images/v2/ic_app_config.svg';
import IcLoginConfig from 'assets/images/v2/ic_login_config.svg';
import IcPayment from 'assets/images/v2/ic_payment.svg';
import IcTracking from 'assets/images/v2/ic_tracking.svg';
import IcLoyalty from 'assets/images/v2/ic_loyalty.svg';
import IcNotification from 'assets/images/v2/ic_notification.svg';
import IcExtensions from 'assets/images/v2/ic_integration.svg';
import IcCollapse from 'assets/images/v2/ic_collapse.svg';
import IcExpand from 'assets/images/v2/ic_expand.svg';
import IcCheckActive from 'assets/images/v2/ic_check_active.svg';
import IcCheckInactive from 'assets/images/v2/ic_check_inactive.svg';
import IcAndroid from 'assets/images/v2/ic_android.svg';
import IcIOS from 'assets/images/v2/ic_ios.svg';
import IcSync from 'assets/images/v2/ic_sync.svg';
import IcDownload from 'assets/images/v2/ic_download.svg';
import IcQrCode from 'assets/images/v2/ic_qrcode.svg';
import IcPopupCaret from 'assets/images/v2/ic_popup_caret.svg';
import IcAdd from 'assets/images/v2/ic_add.svg';
import IcInstallment from 'assets/images/v2/ic_installment.svg';
import IcBox from 'assets/images/v2/ic_box.svg';
import IcSuccessGreen from 'assets/images/v2/ic_success_green.svg';
import IcErrorRed from 'assets/images/v2/ic_error_red.svg';
import IcMoreHorizontal from 'assets/images/v2/ic_more_horizontal.svg';
import IcCancel from 'assets/images/v2/ic_cancel.svg';
import { BgColorsOutlined, DollarOutlined } from '@ant-design/icons';

export const AppConfigIcon = (
  <img src={IcAppConfig} alt="appConfig" sizes="24" />
);
export const LoginConfigIcon = (
  <img src={IcLoginConfig} alt="loginConfig" sizes="24" />
);
export const TrackingConfigIcon = (
  <img src={IcTracking} alt="trackingConfig" sizes="24" />
);
export const NotificationIcon = (
  <img src={IcNotification} alt="notificationConfig" sizes="24" />
);
export const PaymentIcon = <img src={IcPayment} alt="payment" sizes="24" />;
export const LoyaltyIcon = <img src={IcLoyalty} alt="thirdParty" sizes="24" />;
export const ExtensionsIcon = (
  <img src={IcExtensions} alt="thirdParty" sizes="24" />
);
export const CollapseIcon = <img src={IcCollapse} alt="collapse" sizes="24" />;
export const ExpandIcon = <img src={IcExpand} alt="expand" sizes="24" />;
export const PaymentControllerIcon = (
  <DollarOutlined style={{ fontSize: 24 }} />
);
export const ApolloIcon = (
  <BgColorsOutlined style={{ fontSize: 24 }} />
);
export const CheckActiveIcon = (
  <img src={IcCheckActive} alt="checkActive" sizes="24" />
);
export const CheckInactiveIcon = (
  <img src={IcCheckInactive} alt="checkInactive" sizes="24" />
);
export const AndroidIcon = <img src={IcAndroid} alt="android" sizes="24" />;
export const IosIcon = <img src={IcIOS} alt="ios" sizes="24" />;
export const SyncIcon = <img src={IcSync} alt="sync" sizes="24" />;
export const DownloadIcon = <img src={IcDownload} alt="download" sizes="24" />;
export const QrCodeIcon = <img src={IcQrCode} alt="qr" sizes="24" />;
export const BuildAndReleaseIcon = <img src={IcQrCode} alt="qr" sizes="24" />;
export const PopupCaretIcon = <img src={IcPopupCaret} alt="<" sizes="12" />;
export const AddIcon = <img src={IcAdd} alt="+" sizes="12" />;
export const InstallmentIcon = <img src={IcInstallment} alt="I" sizes="24" />;
export const BoxIcon = <img src={IcBox} alt="B" sizes="24" />;
export const GreenSuccessIcon = <img src={IcSuccessGreen} alt="S" sizes="32" />;
export const RedErrorIcon = <img src={IcErrorRed} alt="E" sizes="32" />;
export const MoreHorizontalIcon = <img src={IcMoreHorizontal} alt="M" sizes="24" />;
export const MoreVerticalIcon = <img src={IcMoreHorizontal} alt="M" sizes="24" style={{ transform: 'rotate(90deg)' }} />; 
export const CancelIcon = <img src={IcCancel} alt="Cancel" sizes="24" />